import { render, staticRenderFns } from "./DriversRemarksList.vue?vue&type=template&id=462f7dfa&"
import script from "./DriversRemarksList.vue?vue&type=script&lang=js&"
export * from "./DriversRemarksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports